import { IConnectRender } from "../../definitions/IConnectRender";
import { IPage } from "../../definitions/page/IPage";

/** Página con segundo sidebar + contenido principal (p. ej. aplicaciones:
 *  sidebar de fechas + mapa). Monta ambos, abre el wrapper (clase `open`) y al
 *  disponer lo limpia y lo cierra para que no quede fantasma al navegar. */
export abstract class BaseSecondSidebarPageContent implements IPage {
  /** Contenido principal de la página (p. ej. el mapa). */
  protected abstract getMainRender(): IConnectRender;

  /** Segundo sidebar de la página (típicamente un `BaseSecondSidebarRender`). */
  protected abstract getSecondSidebarRender(): IConnectRender;

  render(
    pageContent: HTMLDivElement,
    secondSidebarWrapper: HTMLDivElement,
  ): void {
    this._wrapper = secondSidebarWrapper;
    // Marca el page-wrapper: el layout apilado (móvil/tablet) solo aplica a
    // páginas con segundo sidebar.
    this._pageWrapper = secondSidebarWrapper.closest(".sx-page-wrapper");
    this._pageWrapper?.classList.add("sx-page-wrapper--sidebar");

    this._main = this.getMainRender();
    pageContent.innerHTML = this._main.render();
    this._main.connect();

    this._sidebar = this.getSecondSidebarRender();
    secondSidebarWrapper.innerHTML = this._sidebar.render();
    this._sidebar.connect();
    secondSidebarWrapper.classList.add("open");
  }

  /** Dispone contenido y sidebar, cierra/limpia el wrapper y desmarca el
   *  page-wrapper. */
  dispose(): void {
    this._main?.dispose();
    this._sidebar?.dispose();
    if (this._wrapper) {
      this._wrapper.innerHTML = "";
      this._wrapper.classList.remove("open");
    }
    this._pageWrapper?.classList.remove("sx-page-wrapper--sidebar");
    this._main = null;
    this._sidebar = null;
    this._wrapper = null;
    this._pageWrapper = null;
  }

  /** Contenido principal montado (o null). */
  private _main: IConnectRender | null = null;
  /** Sidebar montado (o null). */
  private _sidebar: IConnectRender | null = null;
  /** Wrapper del segundo sidebar (para cerrarlo al disponer). */
  private _wrapper: HTMLDivElement | null = null;
  /** Page-wrapper contenedor (para quitar el modificador al disponer). */
  private _pageWrapper: Element | null = null;
}
